export default "__VITE_ASSET__8f723188__"